import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            betData: {
                category_id: 0,
                date: '',
                numbers: [],
                currentCity: {},
                currentGame: {},
                amountOne: 1,
            },
            rates: null,
        };
    },
    mutations,
    actions,
    getters,
};
